/**
 * en-GB messages added by Phase 4 task W24 (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const w24EnGB = {
    // Security page
    'nav.security': 'Security',
    'nav.security.desc': 'Password rules, two-factor sign-in, Microsoft sign-in and support access.',
    'security.title': 'Security',
    'security.description': 'Password rules, two-factor sign-in, Microsoft sign-in and support access for your organisation.',
    'security.policy.title': 'Password and sign-in rules',
    'security.policy.description': 'Every rule here is off or at the platform default until you change it. A value of 0 turns the rule off.',
    'security.policy.require2fa': 'Require two-factor authentication for everyone',
    'security.policy.require2fa.hint': 'People without it are asked to set it up when they next sign in.',
    'security.policy.sessionIdleMinutes': 'Sign out after this many idle minutes',
    'security.policy.sessionIdleMinutes.hint': '0 uses the platform default.',
    'security.policy.passwordExpiryDays': 'Passwords expire after this many days',
    'security.policy.passwordExpiryDays.hint': '0 means passwords never expire. People who sign in with Microsoft are not affected.',
    'security.policy.passwordReuseCount': 'Do not allow the last this many passwords',
    'security.policy.passwordReuseCount.hint': '0 means no check.',
    'security.policy.reauthHours': 'Ask people to sign in again after this many hours',
    'security.policy.reauthHours.hint': '0 uses the platform default.',
    'security.support.title': 'Support access',
    'security.support.description': 'CloudSign support can only look at your account when you allow it. Each session is time-limited and recorded in your audit log.',
    'security.support.allow': 'Allow CloudSign support to sign in to this organisation',
    'security.support.notify': 'Email administrators when a support session starts',
    // SSO card
    'sso.title': 'Microsoft sign-in',
    'sso.description': 'Let people sign in with their Microsoft 365 work account.',
    'sso.status.connected': 'Connected to Microsoft directory {directory} on {date}.',
    'sso.status.notConnected': 'Not connected.',
    'sso.connect': 'Connect Microsoft 365',
    'sso.connect.hint': 'A Microsoft 365 administrator must approve CloudSign once. You will be sent to Microsoft and brought back here.',
    'sso.disconnect': 'Disconnect',
    'sso.disconnect.confirm': 'Disconnect Microsoft sign-in?',
    'sso.mode': 'Microsoft sign-in is',
    'sso.mode.hint': 'Optional adds a Microsoft button to the sign-in page. Required stops password sign-in.',
    'sso.mode.needsConnect': 'Connect Microsoft 365 before turning this on.',
    'sso.domains': 'Allowed email domains',
    'sso.domains.hint': 'One per line, for example example.co.uk. Leave empty to allow any email address of an existing user.',
    'sso.breakGlass': 'Administrators can still use a password and two-factor code',
    'sso.breakGlass.hint': 'Recommended when sign-in is required, in case Microsoft is unavailable.',
    'sso.satisfiesTwoFactor': 'Count Microsoft sign-in as two-factor',
    'sso.satisfiesTwoFactor.hint': 'People who sign in with Microsoft are not asked for a CloudSign code.',
    'sso.connectedNotice': 'Microsoft 365 is connected.',
    'sso.failedNotice': 'Microsoft 365 could not be connected. Please try again.',
    'sso.disconnected': 'Microsoft sign-in has been disconnected.',
    // Login page and password change
    'auth.sso.or': 'or',
    'auth.passwordChange.title': 'Choose a new password',
    'auth.passwordChange.intro': 'Your password has expired. Choose a new one to carry on.',
    'auth.passwordChange.reuse': 'It must not match your last {count} passwords.',
    'auth.passwordChange.submit': 'Change password',
    'auth.passwordChange.signOut': 'Cancel and sign out',
    // Banners
    'banner.support.text': '{name} is signed in to {tenant} until {time}. Reason: {reason}',
    'banner.support.label': 'Support session',
    'banner.support.end': 'End support session',
    'banner.restriction.label': 'Account notice',
    'banner.restriction.kiosk_grace': 'This account has an overdue invoice. Kiosks keep working for now but will stop signing people in if it is not paid. Contact your administrator.',
    'banner.restriction.read_only': 'This account is on hold for an unpaid invoice, so changes are switched off. People can still sign out and run an evacuation.',
    // Connected apps
    'connectedApps.title': 'Connected apps',
    'connectedApps.description': 'Apps you have allowed to use CloudSign for you, such as the Outlook add-in. Remove one if you no longer use it.',
    'connectedApps.empty': 'No apps are connected to your account.',
    'connectedApps.purpose.outlook': 'Outlook add-in',
    'connectedApps.created': 'Connected {date}',
    'connectedApps.lastUsed': 'Last used {date}',
    'connectedApps.neverUsed': 'Never used',
    'connectedApps.expires': 'Expires {date}',
    'connectedApps.revoke': 'Remove',
    'connectedApps.revokeFor': 'Remove {label}',
    'connectedApps.revoked': 'App removed.',
};
//# sourceMappingURL=w24.js.map